export const invoiceResetPeriods = [
  {
    label: '1 month',
    value: '1',
  },
  {
    label: '3 months',
    value: '3',
  },
  {
    label: '4 months',
    value: '4',
  },
  {
    label: '6 months',
    value: '6',
  },
  {
    label: '12 months',
    value: '12',
  },
];

export const placeholders = [
  { label: 'Year', value: 'YEAR', example: '2023' },
  { label: 'Month', value: 'MONTH', example: 'Jan' },
  { label: 'Sequence', value: 'SEQ', example: '001' },
  { label: 'Client Code', value: 'CLIENT_CODE', example: 'TCS' },
];

export const monthOptions = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
].map((m) => ({ label: m, value: m.toUpperCase() }));
